import React, { useState, useEffect } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const AppReviewModal = ({ isOpen, onClose, taskId }) => {
 const [reviewData, setReviewData] = useState({
 problem_category: '',
 problem_description: '',
 what_liked: '',
 app_rating: 5,
 allow_publication: true,
 task_id: taskId
 });
 const [submitting, setSubmitting] = useState(false);

 const problemCategories = {
 'remote_photo_video': 'Нужны были фото/видео из конкретного места',
 'location_access': 'Не мог сам добраться до локации',
 'urgent_need': 'Нужно было срочно, а знакомых рядом не было',
 'professional_content': 'Нужен был профессиональный контент',
 'location_check': 'Нужна была проверка конкретного места/события',
 'other': 'Другое'
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 setSubmitting(true);

 try {
 const API = import.meta.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
 const token = localStorage.getItem('token');
 
 await axios.post(`${API}/api/app-reviews`, reviewData, {
 headers: { 'Authorization': `Bearer ${token}` }
 });

 alert('Спасибо за ваш отзыв! Он поможет нам стать лучше ');
 onClose();
 } catch (error) {
 console.error('Error submitting app review:', error);
 alert('Ошибка при отправке отзыва. Попробуйте позже.');
 } finally {
 setSubmitting(false);
 }
 };

 const handleSkip = () => {
 // Сохраняем флаг пропуска в localStorage с timestamp
 localStorage.setItem('app_review_skipped', Date.now().toString());
 console.log('Отзыв пропущен пользователем');
 onClose();
 };

 if (!isOpen) return null;

 return (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
 <div className="bg-white rounded-lg max-w-2xl w-full max-h-screen overflow-y-auto">
 <div className="p-6">
 <div className="flex justify-between items-center mb-6">
 <h2 className="text-2xl font-bold text-gray-800">Поделитесь опытом использования Reversia</h2>
 <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">×</button>
 </div>

 <div className="mb-4 p-4 bg-blue-50 rounded-lg">
 <p className="text-sm text-blue-800">Ваш отзыв поможет другим пользователям понять, чем полезна наша платформа!
 </p>
 </div>

 <form onSubmit={handleSubmit}>
 {/* Категория проблемы */}
 <div className="mb-6">
 <label className="block text-sm font-medium text-gray-700 mb-2">Какую проблему помогло решить приложение? *
 </label>
 <select
 value={reviewData.problem_category}
 onChange={(e) =>setReviewData({...reviewData, problem_category: e.target.value})}
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 required
 >
 <option value="">Выберите категорию</option>
 {Object.entries(problemCategories).map(([key, value]) => (
 <option key={key} value={key}>{value}</option>
 ))}
 </select>
 </div>

 {/* Описание проблемы */}
 <div className="mb-6">
 <label className="block text-sm font-medium text-gray-700 mb-2">Как вы раньше решали эту задачу? *
 </label>
 <textarea
 value={reviewData.problem_description}
 onChange={(e) =>setReviewData({...reviewData, problem_description: e.target.value})}
 rows="3"
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 placeholder="Например: Просил знакомых, искал в интернете, ездил сам..."
 required
 />
 </div>

 {/* Что понравилось */}
 <div className="mb-6">
 <label className="block text-sm font-medium text-gray-700 mb-2">Что понравилось больше всего в Reversia? *
 </label>
 <textarea
 value={reviewData.what_liked}
 onChange={(e) =>setReviewData({...reviewData, what_liked: e.target.value})}
 rows="3"
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 placeholder="Например: Быстро нашли исполнителя, качественные фото, удобный интерфейс..."
 required
 />
 </div>

 {/* Рейтинг приложения */}
 <div className="mb-6">
 <label className="block text-sm font-medium text-gray-700 mb-2">Ваша оценка приложения *
 </label>
 <div className="flex space-x-1">
 {Array.from({ length: 5 }, (_, i) => (
 <button
 key={i}
 type="button"
 onClick={() =>setReviewData({ ...reviewData, app_rating: i + 1 })}
 className={`text-3xl ${i < reviewData.app_rating ? 'text-yellow-400' : 'text-gray-300'} hover:text-yellow-400`}
 >
 <Star className={`w-7 h-7 ${i < reviewData.app_rating ? 'fill-yellow-400' : ''}`} />
 </button>
 ))}
 <span className="ml-2 text-sm text-gray-600">({reviewData.app_rating} из 5)</span>
 </div>
 </div>

 {/* Разрешение на публикацию */}
 <div className="mb-6">
 <label className="flex items-center space-x-2">
 <input
 type="checkbox"
 checked={reviewData.allow_publication}
 onChange={(e) =>setReviewData({...reviewData, allow_publication: e.target.checked})}
 className="rounded"
 />
 <span className="text-sm text-gray-700">Разрешаю публиковать мой отзыв на сайте (имя будет показано)
 </span>
 </label>
 </div>

 {/* Кнопки */}
 <div className="flex space-x-4">
 <button
 type="submit"
 disabled={submitting || !reviewData.problem_category || !reviewData.problem_description || !reviewData.what_liked}
 className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
 >
 {submitting ? 'Отправляем...' : 'Отправить отзыв'}
 </button>
 <button
 type="button"
 onClick={handleSkip}
 className="px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
 >Пропустить
 </button>
 </div>
 </form>
 </div>
 </div>
 </div>
 );
};

// User Profile Reviews Section (отзывы о пользователе)
export const UserProfileReviewsSection = ({ user }) => {
 const [reviews, setReviews] = useState([]);
 const [total, setTotal] = useState(0);
 const [averageRating, setAverageRating] = useState(0);
 const [loading, setLoading] = useState(true);
 const [showAll, setShowAll] = useState(false);

 useEffect(() => {
 fetchUserReviews(3);
 // eslint-disable-next-line
 }, [user.id]);

 const fetchUserReviews = async (limit) => {
 try {
 const response = await axios.get(`${API}/api/users/${user.id}/reviews?page=1&limit=${limit}`);
 setReviews(Array.isArray(response.data.items) ? response.data.items : []);
 setTotal(response.data.total || 0);
 setAverageRating(response.data.average_rating || 0);
 } catch (error) {
 console.error('Error fetching user reviews:', error);
 setReviews([]);
 } finally {
 setLoading(false);
 }
 };

 const toggleShowAll = () => {
 const next = !showAll;
 setShowAll(next);
 fetchUserReviews(next ? Math.min(total, 200) : 3);
 };

 const renderStars = (rating) => {
 return Array.from({ length: 5 }, (_, i) => (
 <Star key={i} className={`w-4 h-4 inline ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} />
 ));
 };

 if (loading) {
 return null; // Скрываем блок во время загрузки
 }

 if (total === 0) {
 return null; // 1. Скрываем блок "Отзывы обо мне" если нет отзывов
 }

 const displayReviews = reviews;

 return (
 <div className="reversia-card">
 <h3 className="text-lg font-semibold mb-4 text-center" style={{color: 'var(--reversia-teal)'}}>Отзывы обо мне
 </h3>
 
 {/* Средний рейтинг */}
 <div className="flex items-center justify-center mb-4 p-3 bg-gray-50 rounded-lg">
 <div className="text-2xl font-bold text-gray-800 mr-3">{averageRating}</div>
 <div className="flex flex-col">
 <div className="flex">{renderStars(Math.round(averageRating))}</div>
 <div className="text-sm text-gray-500 text-center">{total} отзыв{total === 1 ? '' : total < 5 ? 'а' : 'ов'}</div>
 </div>
 </div>

 {/* Список отзывов */}
 <div className="space-y-3">
 {displayReviews.map((review, index) => (
 <div key={index} className="p-3 bg-gray-50 rounded-lg">
 <div className="flex items-center justify-between mb-2">
 <div className="flex items-center space-x-2">
 <span className="font-medium text-gray-800">{review.reviewer_name}</span>
 <div className="flex">{renderStars(review.rating)}</div>
 </div>
 <span className="text-sm text-gray-500">
 {new Date(review.created_at).toLocaleDateString('ru-RU')}
 </span>
 </div>
 {review.comment && (
 <p className="text-gray-700 text-sm">{review.comment}</p>
 )}
 </div>
 ))}
 </div>

 {/* Кнопка "Показать все" */}
 {total > 3 && (
 <div className="text-center mt-4">
 <button
 data-testid="user-reviews-toggle-show-all-btn"
 onClick={toggleShowAll}
 className="text-sm px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-50 transition-colors"
 style={{color: 'var(--reversia-teal)'}}
 >
 {showAll ? 'Скрыть' : `Показать все (${total})`}
 </button>
 </div>
 )}
 </div>
 );
};

// App Reviews Section for Main Page (секция отзывов на главной)
export const AppReviewsSection = () => {
 const [reviewsCount, setReviewsCount] = useState(0);
 const [showModal, setShowModal] = useState(false);

 useEffect(() => {
 fetchReviewsCount();
 }, []);

 const fetchReviewsCount = async () => {
 try {
 const API = import.meta.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
 const response = await axios.get(`${API}/api/app-reviews`);
 setReviewsCount(Array.isArray(response.data) ? response.data.length : 0);
 } catch (error) {
 console.error('Error fetching reviews count:', error);
 }
 };

 if (reviewsCount === 0) {
 return null;
 }

 return (
 <>
 <div className="reversia-card text-center">
 <button
 onClick={() =>setShowModal(true)}
 className="inline-flex items-center space-x-2 text-lg font-semibold hover:text-blue-800 transition-colors"
 style={{color: 'var(--reversia-teal)'}}
 >
 <span>Отзывы наших клиентов</span>
 <span className="px-2 py-1 rounded-full text-sm" style={{backgroundColor: 'var(--reversia-gold)', color: 'white'}}>
 {reviewsCount}
 </span>
 </button>
 <p className="text-sm text-gray-500 mt-2">Узнайте, какие задачи помогает решать Reversia
 </p>
 </div>

 <AppReviewsModal 
 isOpen={showModal} 
 onClose={() =>setShowModal(false)} 
 />
 </>
 );
};

// Modal для показа отзывов
export const AppReviewsModal = ({ isOpen, onClose }) => {
 const [reviews, setReviews] = useState([]);
 const [loading, setLoading] = useState(true);
 const [expandedReviews, setExpandedReviews] = useState(new Set());

 const problemCategoryNames = {
 'remote_photo_video': 'Фото/видео из конкретного места',
 'location_access': 'Не мог добраться до локации',
 'urgent_need': 'Срочная задача',
 'professional_content': 'Профессиональный контент',
 'location_check': 'Проверка места/события',
 'other': 'Другое'
 };

 useEffect(() => {
 if (isOpen) {
 fetchAppReviews();
 }
 }, [isOpen]);

 const fetchAppReviews = async () => {
 try {
 const API = import.meta.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
 const response = await axios.get(`${API}/api/app-reviews`);
 setReviews(Array.isArray(response.data) ? response.data : []);
 } catch (error) {
 console.error('Error fetching app reviews:', error);
 } finally {
 setLoading(false);
 }
 };

 const renderStars = (rating) => {
 return Array.from({ length: 5 }, (_, i) => (
 <Star key={i} className={`w-4 h-4 inline ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} />
 ));
 };

 const toggleReviewExpansion = (reviewId) => {
 const newExpanded = new Set(expandedReviews);
 if (newExpanded.has(reviewId)) {
 newExpanded.delete(reviewId);
 } else {
 newExpanded.add(reviewId);
 }
 setExpandedReviews(newExpanded);
 };

 const truncateText = (text, maxLength = 50) => {
 if (text.length <= maxLength) return text;
 return text.substring(0, maxLength) + '...';
 };

 // Подсчет среднего рейтинга
 const averageRating = reviews.length > 0 
 ? (reviews.reduce((sum, review) =>sum + review.app_rating, 0) / reviews.length).toFixed(1)
 : 0;

 if (!isOpen) return null;

 return (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
 <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden">
 
 {/* Header */}
 <div className="p-6 border-b border-gray-200">
 <div className="flex justify-between items-start">
 <div>
 <div className="flex items-center space-x-3 mb-2">
 <h2 className="text-xl font-bold text-gray-800">Отзывы наших клиентов</h2>
 <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-sm">
 {reviews.length}
 </span>
 </div>
 
 {/* Общий рейтинг */}
 <div className="flex items-center space-x-3">
 <div className="text-3xl font-bold text-gray-800">{averageRating}</div>
 <div className="flex flex-col">
 <div className="flex">{renderStars(Math.round(averageRating))}</div>
 <div className="text-sm text-gray-500">{reviews.length} оценки</div>
 </div>
 </div>
 </div>
 
 <button 
 onClick={onClose}
 className="text-gray-400 hover:text-gray-600 text-2xl"
 >
 ×
 </button>
 </div>
 </div>

 {/* Reviews List */}
 <div className="p-6 overflow-y-auto max-h-[calc(80vh-200px)]">
 {loading ? (
 <div className="text-center py-8">
 <div className="text-gray-500">Загрузка отзывов...</div>
 </div>
 ) : (
 <div className="space-y-4">
 {reviews.map((review) => (
 <div key={review.id} className="border-b border-gray-100 pb-4 last:border-b-0">
 <div className="flex items-center space-x-3 mb-3">
 <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
 <span className="text-gray-600 font-medium">
 {review.user_name.charAt(0).toUpperCase()}
 </span>
 </div>
 <div className="flex-1">
 <div className="font-medium text-gray-800">{review.user_name}</div>
 <div className="text-sm text-gray-500">
 1 отзыв • {new Date(review.created_at).toLocaleDateString('ru-RU')}
 </div>
 </div>
 </div>

 <div className="mb-3">
 <div className="flex items-center space-x-2 mb-2">
 <div className="flex">{renderStars(review.app_rating)}</div>
 <span className="text-sm text-gray-500">
 {new Date(review.created_at).toLocaleDateString('ru-RU')}
 </span>
 </div>
 
 <div className="text-sm text-gray-700">
 <div className="mb-2">
 <span className="inline-block text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded mb-2">
 {problemCategoryNames[review.problem_category] || review.problem_category}
 </span>
 </div>
 
 {expandedReviews.has(review.id) ? (
 <div className="space-y-2">
 <div>
 <span className="font-medium">Проблема: </span>
 {review.problem_description}
 </div>
 <div>
 <span className="font-medium">Что понравилось: </span>
 {review.what_liked}
 </div>
 </div>
 ) : (
 <div>
 {truncateText(`${review.problem_description} ${review.what_liked}`, 50)}
 </div>
 )}
 
 {(review.problem_description + review.what_liked).length > 50 && (
 <button
 onClick={() =>toggleReviewExpansion(review.id)}
 className="text-blue-600 text-sm mt-2 hover:underline"
 >
 {expandedReviews.has(review.id) ? 'Скрыть' : 'Смотреть полностью'}
 </button>
 )}
 </div>
 </div>
 </div>
 ))}
 </div>
 )}
 </div>
 </div>
 </div>
 );
};
